module.exports = __webpack_public_path__ + "1637af7040c3330b7b4640f0c1acc96f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.html
// module id = 2157
// module chunks = 0